import { call, put } from 'redux-saga/effects';
import {
  changeActivityRole,
  updateActivityRoleFailure,
  updateActivityRoleSuccess,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { UpdateActivityRoleRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { updateActivityRole } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { updateSubmissionLog } from 'store/organisation/actions';
import { ActivityRoles, SubmissionUpdateField } from 'store/app/enums';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* updateActivityRoleSaga(
  action: UpdateActivityRoleRequestAction
) {
  try {
    let err: ApiError | null;
    const { activityRoleUpdateRequest, automaticRequest } = action.payload;

    const response: ApiResponse = yield call(
      updateActivityRole,
      activityRoleUpdateRequest
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;
    yield put(
      changeActivityRole(
        activityRoleUpdateRequest.activityRole, //@ts-ignore
        activityRoleUpdateRequest.memberUser?.accountUuid
      )
    );

    yield put(updateActivityRoleSuccess());

    if (
      !automaticRequest &&
      activityRoleUpdateRequest.activityRole !== ActivityRoles.REMOVE_CLIENT &&
      activityRoleUpdateRequest.activityRole !== ActivityRoles.REMOVE_REVIEWER
    ) {
      const message: MessageData = {
        title: i18n.t('users.user-permissions'),
        description: i18n.t('notifications.the-selected-user-has-been-given-access-rights-to-view-this-enti'),
        type: MessageStates.INFO,
      };

      yield put(turnMessageOn(message));
    }
    yield put(
      updateSubmissionLog(
        activityRoleUpdateRequest.mappingId,
        SubmissionUpdateField[
          activityRoleUpdateRequest.activityRole
            .toUpperCase()
            .replace(' ', '_')
            .replace('-', '_')
        ],
        activityRoleUpdateRequest.memberUser,
        activityRoleUpdateRequest.dataLogId
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateActivityRoleFailure());
  }
}
